import React, { useEffect, useState } from "react";
import FormActions from "../FormAction/FormActions";
import { RequestServiceActions } from "services/services-mia/RequestServiceActions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { modalData, rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";
import { ACTIONS } from "consts/Actions";
import { RequestServiceGet } from "services/services-mia/RequestServiceGet";

export default function UpdateModal({ updateList }) {
    const credentials = useRecoilValue(userCredentials);
    const setModalDetails = useSetRecoilState(modalData);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const xgridRowSelected = useRecoilValue(rowSelected);
    const setXgridRowSelected = useSetRecoilState(rowSelected)
    const [data, setData] = useState({})
    const handleGetData = async () => {
        const body = {
            service: "SBMDocumentoGet",
            params: {
                sbmDocumentoId: xgridRowSelected.row.id
            },
        }
        // console.log(body)
        const response = await RequestServiceGet(body, credentials);
        setData(response[0])
    }
    const handleSubmit = async (values) => {

        try {
            const body = {
                service: "SBMDocumentoUpd",
                params: {
                    sbmDocumentoId: xgridRowSelected.row.id,
                    sbmTipoDocumentoId: values.tipoDocumento,
                    sbmDocumentoFecha: values.fechaDocumento,
                    sbmDocumentoNombre: values.nombreDocumento,
                    sbmDocumentoDescripcion: values.descripcion,
                    sbmDocumentoRequiereFirma: values.requiereFirma === true ? "Y" : "N",
                    sbmDocumentoFirmantesExternos: values.cantFirmantesExternos,
                    sbmDocumentoFirmantesInternos: values.cantFirmantesInternos,
                    sbmDocumentoVersion: xgridRowSelected.row.version,
                    sbmDocumentoReferencia: values.referencia,
                    crearNuevoGrupo: values.grupo === "NG" ? "Y" : "N",
                    sbmDocumentoGrupoId: values.grupo === "NG" ? null : values.grupoId
                }

            }
            await RequestServiceActions(body, credentials, ACTIONS.UPDATE, setSnackbarInfo);
            setModalDetails({ isOpen: false });
            await updateList();
        } catch (e) {

        }
    }
    useEffect(() => {
        handleGetData()
        return () => {
            setXgridRowSelected({ status: false, row: {} })
        }
    }, [])

    return (
        <section>
            <main>
                {data.sbmDocumentoId && <FormActions handleSubmit={handleSubmit} initialValues={{
                    requiereFirma: data.sbmDocumentoRequiereFirma === "Y" ? true : false,
                    tipoDocumento: data.sbmTipoDocumentoId,
                    nombreDocumento: data.sbmDocumentoNombre,
                    fechaDocumento: data.sbmDocumentoFecha,
                    cantFirmantesInternos: data.sbmDocumentoFirmantesInternos,
                    cantFirmantesExternos: data.sbmDocumentoFirmantesExternos,
                    descripcion: data.sbmDocumentoDescripcion,
                    referencia: data.sbmDocumentoReferencia,
                    grupo: data.sbmDocumentoGrupo,
                }} />}
            </main>
        </section>
    );
}